import React from "react";
import { Link } from "react-router-dom";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

import { connect } from "react-redux";
import Dropable from "../Dropable";
import { CATEGORY } from "../TasksList/constants";
import TodayIcon from '@material-ui/icons/Today';

const CalendarMenu = props => (
  <div>
    <Dropable name={CATEGORY.FOCUS}>
      <ListItem button>
        <ListItemIcon classes={{ root: 'new-MuiListItemIcon-root' }}>
          <Link to="/today">
            <TodayIcon />
            {!props.isOpenDrawer &&
              <div>{`Today`}</div>}
          </Link>
        </ListItemIcon >
        <Link to="/today">
          <ListItemText primary={`Today`} />
        </Link>
      </ListItem>
    </Dropable>
  </div>
);

const mapStateToProps = state => {
  function isFocus(idTask) {
    const task = state.tasks[idTask];
    return (task.focus && !task.project && !task.done);
  }

  const tasks =
    state.tasks &&
    Object.keys(state.tasks)
      .filter(isFocus);

  return {
    tasksFoucsCouter: tasks ? tasks.length : 0
  };
};

export default connect(mapStateToProps, null)(CalendarMenu);

